
































import { Component, Vue } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

/**
 * task-eak-726, этап 4: список строк, отклонённых при частичном сохранении формы "Заявки АБП".
 * По образцу c-checkup-modal (budget-checkup-modal.vue), но с колонками ГУ и Причина -
 * согласование по этим строкам не выполнено, пользователь должен их исправить и сохранить снова.
 */
@Component({name: 'c-partial-save-modal'})
export default class CBudgetPartialSaveModal extends Vue {
    private showModal = false;
    private dataLst: any [] = [];
    private customTitle: string | null = null; // заголовок, переданный вызывающим (например, для перехода); null - прежний

    /**
     * @param dataLst отклонённые строки
     * @param partialTitle свой заголовок; всегда перезаписывает прежний: окно закрывается и мимо okClk (крестик, Esc),
     * иначе заголовок перехода "прилип" бы к следующему обычному сохранению
     */
    private showEvent(dataLst: any, partialTitle?: string) {
        if (!dataLst || !dataLst.length) { return; }
        this.customTitle = partialTitle || null;
        this.dataLst = dataLst;
        this.showModal = true;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: this.customTitle || this.getBudgetText('budget-event.partial-save.title'),
            prg: this.getBudgetText('budget-event.partial-save.prg'),
            ppr: this.getBudgetText('budget-event.partial-save.ppr'),
            project: this.getBudgetText('budget-event.partial-save.project'),
            gu: this.getBudgetText('budget-event.partial-save.gu'),
            reason: this.getBudgetText('budget-event.partial-save.reason'),
            close: this.getBudgetText('budget-event.partial-save.close')
        }
        return obj;
    }

    private okClk() {
        this.showModal = false;
        this.dataLst = [];
    }
}
